import React from "react";
import {
  GraduationCap,
  Construction,
  CalendarDays,
  FileText,
  Briefcase,
  BarChart3,
  BellRing,
  Sparkles,
} from "lucide-react";

const InternshipPlannerComingSoon = () => {
  const features = [
    {
      icon: <Briefcase size={22} />,
      title: "Application Tracking",
      description: "Monitor every internship application from one place.",
    },
    {
      icon: <CalendarDays size={22} />,
      title: "Deadline Management",
      description: "Stay informed about important application timelines.",
    },
    {
      icon: <FileText size={22} />,
      title: "Document Organization",
      description: "Manage resumes, certificates, and supporting documents.",
    },
    {
      icon: <BellRing size={22} />,
      title: "Smart Reminders",
      description: "Receive timely notifications for upcoming activities.",
    },
    {
      icon: <BarChart3 size={22} />,
      title: "Progress Dashboard",
      description: "Track your internship journey with clear insights.",
    },
    {
      icon: <Sparkles size={22} />,
      title: "Interview Preparation",
      description: "Access tools and resources to prepare with confidence.",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-orange-50 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-5xl bg-white border border-gray-200 rounded-3xl shadow-xl overflow-hidden">

        {/* Header */}
        <div className="px-6 sm:px-10 pt-10 text-center">
          <div className="mx-auto w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-orange-100 flex items-center justify-center">
            <GraduationCap
              size={42}
              className="text-orange-500 sm:w-12 sm:h-12"
            />
          </div>

          <div className="inline-flex items-center gap-2 mt-6 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-semibold">
            <Construction size={16} />
            Coming Soon
          </div>

          <h1 className="mt-6 text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            Internship Planner
          </h1>

          <p className="mt-5 max-w-3xl mx-auto text-gray-600 text-base sm:text-lg leading-8">
            We're currently developing this module to provide a practical and
            reliable internship planning experience for students.
          </p>

          <p className="mt-4 max-w-3xl mx-auto text-gray-500 leading-7">
            Rather than releasing an incomplete feature, we're taking the time
            to build a solution that helps students organize applications,
            manage deadlines, prepare for interviews, and track their overall
            internship progress.
          </p>
        </div>

        {/* Features */}
        <div className="px-6 sm:px-10 py-10">
          <h2 className="text-xl font-semibold text-center text-gray-900 mb-8">
            Planned Features
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="rounded-2xl border border-gray-200 p-6 bg-gray-50 hover:bg-white hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-orange-100 text-orange-600 flex items-center justify-center mb-4">
                  {feature.icon}
                </div>

                <h3 className="font-semibold text-gray-900 text-lg">
                  {feature.title}
                </h3>

                <p className="mt-2 text-sm leading-6 text-gray-600">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 px-6 sm:px-10 py-8 text-center">
          <p className="text-gray-500 leading-7 max-w-2xl mx-auto">
            Thank you for your patience. We look forward to bringing you an
            internship planner that is genuinely useful and designed to support
            students throughout their placement journey.
          </p>

          <p className="mt-6 text-sm text-gray-400">
            Made with ❤️ by{" "}
            <span className="font-semibold text-gray-600">
              The Datazen Team
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default InternshipPlannerComingSoon;